import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { formatApiError } from "../auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async e => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/auth/password-reset/request`, { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="auth-shell" data-testid="forgot-page">
      <div className="auth-card">
        <Link to="/" className="auth-brand" data-testid="auth-brand-link">
          <img src="/logo.png" alt="GoPrintPack" className="auth-logo"/>
        </Link>
        <h1>Reset your password</h1>
        <p className="auth-sub">Enter the email address linked to your account. We'll email you a one-time reset link valid for 30 minutes.</p>

        {sent ? (
          <div className="auth-success" data-testid="forgot-success">
            <p><b>Check your inbox.</b> If an account exists for <b>{email}</b>, a reset link has just been sent. It expires in 30 minutes.</p>
            <p style={{ marginTop: 10, fontSize: 13, color: "#6b7280" }}>Didn't get the email? Check spam or wait a minute and try again.</p>
            <div className="auth-alt">
              <Link to="/login" data-testid="back-to-login">← Back to sign in</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="auth-form">
            <label>Email
              <input data-testid="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" placeholder="you@company.com"/>
            </label>
            {err && <div className="auth-error" data-testid="forgot-error">{err}</div>}
            <button data-testid="forgot-submit" className="primary-btn full" disabled={busy}>
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div className="auth-alt">
              <Link to="/login" data-testid="back-to-login">← Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
